module.exports = __webpack_public_path__ + "static/media/threedots.ac8c07ce.svg";